<template>
  <div class='xy-content-module'>
    <div class='xy-content-body'>
      <div class="changeAll" >
        <div class="chang-school" @click="showSchool">
          <span>{{schoolName ? schoolName:''}}</span>
          <img src="./img/down.png" alt="" >
        </div>
        <div class="chang-grade" @click="showGrade">
          <span>{{gradeName ? gradeName: ''}}</span>
          <img src="./img/down.png" alt="" >
        </div>
        <div class="chang-class" @click="showClass">
          <span>{{className ? className : ''}}</span>
          <img src="./img/down.png" alt=""  v-show="className">
        </div>
      </div>
      <van-popup v-model="isShowschool" position="bottom" :style="{ height: '50%' }" >
        <div style="text-align: center;" v-for="(item,index) in schoolList" :key="index" @click="changeSchool(item,'checked')">
          <div style="font-size:18Px;padding:18px">{{item.SchoolDistrictFullName}}</div>
        </div>
      </van-popup>
      <van-popup v-model="isShowgrade" position="bottom" :style="{ height: '50%' }" @click-overlay="onGrade">
        <div style="text-align: center;" v-for="(item,index) in layerList" :key="index" @click="changeGrade(item,'checked')">
          <div style="font-size:18Px;padding:18px">{{item.label}}</div>
        </div>
      </van-popup>
      <van-popup v-model="isShowclass" position="bottom" :style="{ height: '50%' }" @click-overlay="onClass">
        <div style="text-align: center;" v-for="(item,index) in layerListGrade" :key="index" @click="changeClass(item)">
          <div style="font-size:18Px;padding:18px">{{item.label ? item.label:'没有班级可选' }}</div>
        </div>  
      </van-popup>
      <div class="search-all">
        <van-form action=""  class="search">
          <van-search
            v-model="searchTheme"
            placeholder="请输入活动名称"
            @search="onSearch"
            @cancel="onCancel"
            shape="round"
            left-icon="searchImg"
            >
            <div slot="left-icon" class="searchImg">
              <img :src="searchImg" alt="">
            </div>
          </van-search>
        </van-form>
      </div>
        <div class="assessView null-data" v-if="list.length === 0 && isLoad">
          <img src="@/assets/common/moblie-no-data.png" />
          <div>该搜索条件下没有结果。</div>
        </div>
      <div v-else class="MyActivityEvaluation">
        <van-pull-refresh v-model="isLoading" class="visitlists-refresh" @refresh="onRefresh">
          <!-- 释放提示 -->
          <template #pulling>
            <span style="font-size:14Px">下拉即可刷新...</span>
          </template>
          <!-- 下拉提示 -->
          <template #loosing>
            <span style="font-size:14Px">释放即可刷新...</span>
          </template>
          <van-list
          class="refreshWrap"
          v-model="isRefresh"
          :finished="finished"
          finished-text="没有更多了"
          loading-text=" "
          @load="onLoad"
          >
          <ul>
            <li v-for="(item,index) in list" :key="index">
              <div class="left-all">
                  <div class="left-all-text">
                      <p>{{item.ActivityCourseProjectName}}</p>
                      <span>{{item.ActivityCourseTypeName}}</span>
                  </div>
                  <span style="margin-right:13px">活动时间</span>
                   <span class="left-all-time">{{xy.moment(item.ActivityCourseStartTime).format('YYYY-MM-DD HH:mm')}}
                     至
                   </span>
                  <span class="left-all-time">{{xy.moment(item.ActivityCourseEndTime).format('YYYY-MM-DD HH:mm')}}</span>
              </div>
              <div class="right-all">
                  <div class="info-btn" @click="enterDetal(item)">评价录入</div>
              </div>
            </li>
          </ul>
          </van-list>
        </van-pull-refresh>
      </div>
    </div>
    <div v-if="showCover" class="showCover">
      <van-popup v-model="showCover">
        <div class="mask">
          <img src="./img/notice.png" alt="">
          <div class="text">为了更好的使用，请您横屏使用</div>
          <div class="close" @click="showCover =  false">
            知道了
          </div>
        </div>
      </van-popup>
    </div>
  </div>
</template>
<script>
  import { Toast } from 'vant'
  export default {
    name: 'ActivityEvaluationDetails',
    data () {
      return {
        schoolList:[],
        layerList:[
          {
            'label': '所有学年',
            'value': 0,
            'children': [{
              'value': 0,
              'label': '所有学期',
              'children': []
            }]
          }
        ],
        layerListGrade:[],
        // 弹出层展示
        schoolName:'',
        gradeName:'',
        className:'',
        // 展示对应ID
        schoolId:'',
        gradeId:'',
        classId:'',

        show:false,
        isShowschool:false,
        isShowgrade:false,
        isShowclass:false,

        pageIndex: 1,
        pageSize: 15,
        total: 0, //总共的数据条数
        isLoading: false, //下拉刷新状态
        isRefresh: false, // 是否加载中
        finished: false, // 加载是否完成
        searchTheme:'',
        list:[],

        isLoad: false,
        ApplicationID:0,
        ApplicationSubMenuID:0,
        onloaded:false,
        searchImg: require('./img/search.png'),
        oldSchoolData:[],
        showCover:false,
        num:0,
      }
    },
    created () {
      Toast.setDefaultOptions('loading', { duration: 0 })
      console.log(this.$store.state.evaluation.ipadpjgetMenuIDs)
      this.ApplicationID = this.$store.state.evaluation.ipadpjgetMenuIDs[0]
      this.ApplicationSubMenuID = this.$store.state.evaluation.ipadpjgetMenuIDs[1]
    },
    mounted() {
        window.addEventListener("resize", this.watch, false);
        this.watch();
    },
    beforeDestroy() {
    // 移除监听
      window.removeEventListener("resize", this.watch, false);
    },
    methods :{
      watch(){
        console.log(this.num)
        // if(!window.isIpad){
          // 判断横竖屏
          let width = document.documentElement.clientWidth;
          let height = document.documentElement.clientHeight;
          if(height>width){
            this.showCover = true
            this.num = 0
          }else{
            this.num =  1
            this.onLoad()
            this.showCover = false
          }
        // }else{
        //   this.num =1
        // }
      },
      loading() {
        Toast.loading({
          message: '加载中...',
          className: 'ipad_toast',
          forbidClick: true
        })
      },
      unloading() {
        Toast.clear()
      },
      fail(a) {
        Toast.fail({
          message: a,
          className: 'ipad_toast',
          forbidClick: true
        })
      },
      showSchool(){
        this.isShowschool = true
        this.isShowgrade = false
        this.isShowclass = false
      },
      showGrade(){
        this.isShowschool = false
        this.isShowgrade = true
        this.isShowclass = false
      },
      showClass(){
        this.isShowschool = false
        this.isShowgrade = false
        this.isShowclass = true
      },
      //获取学年学期
      async GetUserRangeClassPermission() {
        let res = await this.xyapi.get(`${this.xyMApi}/xy/comm/GetSessionNodeList`)
        if (res.success) {
          this.layerList = this.layerList.concat(res.data)
          let index = this.layerList.map(function (item) {
            return item.IsCurrent
          }).indexOf(true)
          if (index !== -1) {
            let index1 = this.layerList[index].children.map(function (item) {
              return item.IsCurrent
            }).indexOf(true)
            if (index1 !== -1) {
              this.changeGrade(this.layerList[index])
              this.changeClass(this.layerList[index].children[index1])
            } else {
              this.changeGrade(this.layerList[0])
              this.changeClass(this.layerList[0].children[0])
            }
          } else {
            for (let i = 0; i < this.layerList.length; i++) {
              if (this.layerList[i].children.length > 0) {
                this.changeGrade(this.layerList[i])
                this.changeClass(this.layerList[i].children[0])
                break
              }
            }
          }
        } else {
          this.fail(res.msg)
        }
      },
      // 获取校区
      async getSchool() {
        let res = await this.xyapi.get(`${this.xyMApi}/xy/comm/SchoolDistrictList`)
        if (res.success) {
          this.schoolList = res.data
          this.schoolList.unshift({
            SchoolDistrictID: 0,
            SchoolDistrictFullName: '全部校区'
          })
          this.schoolId = res.data[0].SchoolDistrictID
          this.schoolName = res.data[0].SchoolDistrictFullName
          this.GetUserRangeClassPermission()
        } else {
          this.fail(res.msg)
        }
        console.log(this.layerList)
      },
      //选择校区
      changeSchool(item,ischeck){
        this.pageIndex = 1
        this.schoolName = item.SchoolDistrictFullName
        this.schoolId = item.SchoolDistrictID
        this.isShowschool = false
        if(ischeck === 'checked'){
          this.isShowgrade = true
        }else{
          //默认选择第一个
          this.gradeName = this.layerList.length>0 ? this.layerList[0].label : ''
          this.changeGrade(this.layerList[0])
        }
      },
      //选择年级
      changeGrade(item,ischeck){
        this.pageIndex = 1
        this.gradeName = item.label
        this.gradeId = item.value
        this.isShowgrade = false
        this.layerListGrade = item.children
        //默认选择第一个
        if(ischeck === 'checked'){
          this.isShowclass = true
        }
      },
      //班级
      changeClass(item){
        this.className = item.label
        this.classId = item.value
        this.isShowclass = false
        this.onloaded = true;
        this.pageIndex = 1;
        this.isLoading = false;
        this.list = []
        this.finished = false;
        this.onLoadlist()
        this.oldSchoolData = {
          sName:this.schoolName,
          sId:this.schoolId,
          sList:this.schoolList,
          gName:this.gradeName,
          gId:this.gradeId,
          gList:this.layerList,
          cName:this.className,
          cId:this.classId,
          cList:this.layerListGrade
        }
      },
      //点击蒙层取消选择年级-班级
      onGrade(){
        this.schoolName = this.oldSchoolData.sName
        this.schoolId = this.oldSchoolData.sId
        this.schoolList = this.oldSchoolData.sList
        this.gradeName = this.oldSchoolData.gName
        this.gradeId = this.oldSchoolData.gradeId
        this.layerList = this.oldSchoolData.gList
        this.className = this.oldSchoolData.cName
        this.classId = this.oldSchoolData.cId
        this.layerListGrade = this.oldSchoolData.cList
      },
      onClass(){
        this.schoolName = this.oldSchoolData.sName
        this.schoolId = this.oldSchoolData.sId
        this.schoolList = this.oldSchoolData.sList
        this.gradeName = this.oldSchoolData.gName
        this.gradeId = this.oldSchoolData.gradeId
        this.layerList = this.oldSchoolData.gList
        this.className = this.oldSchoolData.cName
        this.classId = this.oldSchoolData.cId
        this.layerListGrade = this.oldSchoolData.cList
      },
      onLoad(){
          console.log("onloaded",this.onloaded)
        if(this.num !== 0){
          if (!this.onloaded){
            this.getSchool()
          }else{
            this.onLoadlist()
          }
        }
      },
     //获取接口数据
      async onLoadlist(){
          await this.getList();
          // 加载状态结束
          this.isRefresh = false;
          this.pageIndex++;   
      },
      //下拉加载
      onRefresh() {
          this.pageIndex = 1;
          this.isLoading = false;
          this.list = []
          this.finished = false;
          this.onLoadlist()
      },
      async getList() {
        this.loading()
        let params = {
          PageIndex: this.pageIndex,
          PageSize: this.pageSize,
          SchoolDistrictID: this.schoolId,
          AcademicYearID: this.gradeId,
          AcademicSessionID: this.classId,
          SearchText: this.searchTheme,
          ApplicationID:this.ApplicationID,
          ApplicationSubMenuID:this.ApplicationSubMenuID
        }
        let res = await this.xyapi.get(`${this.xyMApi}/eva/api/ActivityCourseProjectPad/GetTeacherProjectByPage`, params)
        this.unloading()
        if (res !== undefined && res.success) {
          // 将新数据与老数据进行合并
          if (res.data === null) {
            this.finished = true
            return
          }
          this.list = this.list.concat(res.data.data?res.data.data:[])
          this.totalRecords = res.data.totalRecords //后端传的总条数
          this.isLoad = true
             // console.log(this.list)
          //如果列表数据条数>=总条数，不再触发滚动加载
          if (this.list === null || this.list.length === 0 || this.list.length >= this.totalRecords) {
            this.finished = true
            return
          }
        } else {
          this.fail(res.msg)
          this.finished = true
        }
      },
      //进入详情
      enterDetal(item) {
        let date = new Date().getTime()
        let start = new Date(item.ActivityCourseEvaStartTime.replace(/-/g,"/")).getTime()
        let end = new Date(item.ActivityCourseEvaEndTime.replace(/-/g,"/")).getTime()
        let isEdit = true
        if (date < start) {
          this.fail('评价时间未开始。')
          return false
        } else if (date > end) {
          this.fail('评价时间已结束。')
          isEdit = false
          return false
        }
        this.$router.push({
            path: "/ipad/ActivityEvaluationDetails",
            query: {
              schoolId: this.schoolId,
              gradeId: this.gradeId,
              classId: this.classId,
              ActivityCourseProjectID: item.ActivityCourseProjectID,
              ActivityCourseScoreType: item.ActivityCourseScoreType,
              isEdit: isEdit
            }
        })
      },
      //搜索
      onSearch(val) {
        this.searchTheme = val
        this.pageIndex = 1;
        this.isLoading = false;
        this.list = []
        this.finished = false;
        this.onLoadlist()
      },
      onCancel() {

      },
    }
  }
</script>
<style lang='less' scoped>
/deep/ .van-cell {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
/deep/ .van-list__finished-text{
    font-size: 14Px;
}
/deep/ .van-search{
    padding: 0;
}
/deep/ .van-search__content--round{
    height: 33px;
}
/deep/ .van-field__control{
    font-size: 14Px;
}
/deep/ .van-icon-clear{
    font-size: 16Px;
}
.assessView {
  width: 100%;
  height: 670px;
}
.null-data {
  margin-top: 100px;
  text-align: center;
  div {
    // prettier-ignore
    font-size:18Px;
  }
}
.xy-content-module{
    position: absolute;
    top: 44px;
    bottom: 10px;
    left: 0;
    right: 0;
    overflow-x: hidden;
    overflow-y: auto;
}
.search-all{
    width: 100%;
    display: flex;
    justify-content: center;
    padding-bottom: 20px;
    background: #fff;
    .search{
        width: 95%;
        //background: #f1f1f1;
        border-radius: 40px;
        position: relative;
        input{
            width: 100%;
            height: 100%;
            border: none;
            outline: none; 
            background: #f1f1f1;
            border-radius: 40px;
            text-indent:46px;
            font-size: 18Px;
        }
        img{
            position: absolute;
            width: 24px;
            height: 24px;
            top:22px;
            left:12px;
        }
    }
    .searchImg {
      width: 16px;
      height: 16px;
      position: relative;
      img {
        width: 16px;
        height: 16px;
        left: 0;
        top: 0;
      }
    }
}

.changeAll{
  height: 44px;
  width: 100%;
  font-size: 15Px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  background: #fff;
  div{
    padding:10px;
    flex: 1;
    text-align: center;
    img{
      width:10px;
      height:6px;
      margin-left:5px;
    }
  }
}
.MyActivityEvaluation{
    width: 100%;
    height: auto;
    background: #f5f5f5;
    ul{
        width: 100%;
        height: auto;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding-top: 14px;
        padding-bottom: 20px;
        li{
            width: 96%;
            height: auto;
            background: #fff;
            margin: 10px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 20px;
            .left-all{
                // width: 84%;
                .left-all-text{
                    display: flex;
                    align-items: flex-start;
                    p{
                        font-size: 18Px;
                        font-weight: bold;
                        word-wrap:break-word;
                        word-break: break-all;
                        display: inline-block;
                        max-width: 690px;
                        line-height: 32px;
                    }
                    span{
                        font-size: 12Px;
                        color: #1677FF;
                        display: inline-block;
                        background: #edf5ff;
                        border: 1px solid #97c3ff;
                        border-radius: 20px;
                        text-align: center;
                        line-height: 20px;
                        margin-top: 3px;
                        margin-left: 10px;
                        padding: 1px 9px;
                        // width: 86px;
                    }
                }
                span{
                    font-size: 16Px;
                    color: rgba(26,26,26,0.42);
                }
            }
        }
    }
}
  .info-btn {
    width: 96px;
    height: 32px;
    background: #1677ff;
    color: #fff;
    border-radius: 25px;
    text-align: center;
    line-height: 32px;
    font-size: 14Px;
  }

.mask{
  width: 600px;
  height: 365px;
  background: #ffffff;
  border-radius: 12px;
  position: relative;
  img{
    position: absolute;
    top: -82px;
    left: 50%;
    width:162px;
    height: 202px;
    transform: translate(-50%,7px)
  }
  .text{
    font-size: 30px;
    font-family: PingFangSC, PingFangSC-Regular;
    font-weight: 400;
    text-align: center;
    color: #2b2b2b;
    padding-top: 141px;
  }
  .close{
    margin:70px auto;
    width: 200px;
    height: 70px;
    background: #1677ff;
    border-radius: 35px;
    font-size: 30px;
    font-family: PingFangSC, PingFangSC-Regular;
    font-weight: 400;
    color:#fff;
    text-align: center;
    line-height: 70px;
  }
}
.showCover{
  /deep/ .van-popup{
  overflow-y: inherit;
  }
}
</style>
